<template>
  <section class="featured-images flex">
    <div v-if="content" class="container">
      <img v-for="(image, index) in content[0].field_featured_images" :src="image.url" :alt="index" :key="index">
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      content: [],
      content: this.getContent()
    }
  },
  methods: {
    getContent() {
      this.$http.get("https://" + window.location.host + "/bonnyoaks/api/blocks/featured-images?_format=json").then(response => {
          this.content = response.body;
      }, response => {
          console.log("Error fetching data from URL!");
      });
    }
  }
}
</script>
